import { actions as CyberConcierge } from "@src/Actions/Reducers/CyberConciergeReducer"
import history from "@src/browserHistory"
import C from "@src/Controller"
import { IGetCyberConciergeAlert } from "@src/Sagas/types"
import { axiosInstance } from "@src/Tools/AxiosInstance"
import { ViewTypes } from "@src/types"
import { put, takeLeading } from "redux-saga/effects"

function* getCyberConciergeConfig() {
  try {
    yield put(CyberConcierge.getCyberConciergeConfigRequest())
    const { data } = yield axiosInstance.get(
      `/api/cyberconcierge/cyberConciergeConfig`,
    )
    if (data.success) {
      yield put(CyberConcierge.getCyberConciergeConfigSuccess(data))
    }
  } catch (e) {
    yield put(CyberConcierge.getCyberConciergeConfigFailure(e))
  }
}

function* getCyberConciergeAlerts() {
  try {
    yield put(CyberConcierge.getCyberConciergeAlertsRequest())
    const { data } = yield axiosInstance.get(
      `/api/cyberconcierge/cyberConciergeAlerts`,
    )
    if (data.success) {
      yield put(CyberConcierge.getCyberConciergeAlertsSuccess(data.alerts))
    }
  } catch (e) {
    yield put(CyberConcierge.getCyberConciergeAlertsFailure(e))
  }
}

function* getCyberConciergeAlert(action: IGetCyberConciergeAlert) {
  try {
    yield put(CyberConcierge.getCyberConciergeAlertRequest())
    const { data } = yield axiosInstance.get(
      `/api/cyberconcierge/cyberConciergeAlert?conciergeMessageId=${action.payload}`,
    )
    if (data.success) {
      yield put(CyberConcierge.getCyberConciergeAlertSuccess(data))
    } else {
      throw new Error(data.error)
    }
  } catch (e) {
    yield put(CyberConcierge.getCyberConciergeAlertSuccess(e))
    C.toastNotification("Something went wrong, please try again.", "danger")
    history.push(`${ViewTypes.cyberConcierge}/messages`)
  }
}

function* getCyberConciergeWeakness(action: IGetCyberConciergeAlert) {
  try {
    yield put(CyberConcierge.getCyberConciergeWeaknessRequest())
    const { data } = yield axiosInstance.get(
      `/api/cyberconcierge/weakness?weaknessId=${action.payload}`,
    )
    if (data.success) {
      yield put(CyberConcierge.getCyberConciergeWeaknessSuccess(data))
    } else {
      throw new Error(data.error)
    }
  } catch (e) {
    yield put(CyberConcierge.getCyberConciergeWeaknessSuccess(e))
    C.toastNotification("Something went wrong, please try again.", "danger")
    history.push(`${ViewTypes.cyberConcierge}/weaknesses`)
  }
}

function* getCyberConciergeWeaknesses() {
  try {
    yield put(CyberConcierge.getCyberConciergeWeaknessesRequest())
    const { data } = yield axiosInstance.get(
      "/api/cyberconcierge/cyberConciergeWeaknesses",
    )
    if (data.success) {
      yield put(CyberConcierge.getCyberConciergeWeaknessesSuccess(data))
    }
  } catch (e) {
    history.push(`${ViewTypes.cyberConcierge}/about`)
    C.toastNotification("Something went wrong, please try again.", "danger")
    yield put(CyberConcierge.getCyberConciergeWeaknessesFailure(e))
  }
}

export function* cyberConciergWatcherSaga() {
  yield takeLeading(
    "GET_CYBER_CONCIERGE_CONFIG_WATCHER",
    getCyberConciergeConfig,
  )
  yield takeLeading(
    "GET_CYBER_CONCIERGE_ALERTS_WATCHER",
    getCyberConciergeAlerts,
  )
  yield takeLeading("GET_CYBER_CONCIERGE_ALERT_WATCHER", getCyberConciergeAlert)
  yield takeLeading(
    "GET_CYBER_CONCIERGE_WEAKNESS_WATCHER",
    getCyberConciergeWeakness,
  )
  yield takeLeading(
    "GET_CYBER_CONCIERGE_WEAKNESSES_WATCHER",
    getCyberConciergeWeaknesses,
  )
}
